import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';
import { AutoCloseField } from 'src/pages/ControlDeskPage/ProjectControls/ProjectSettingsModal/AutoCloseField';
import moment from 'moment/moment';

export const EditZohoEmailAdvancedSettings = ({ currentProject }) => {
  const { control, watch, resetField } = useFormContext();
  const isAutocloseEnabled = watch('autocloseEnabled');
  const duration = currentProject?.autoclose_time_window_minutes
    ? moment.duration(currentProject?.autoclose_time_window_minutes, 'minutes')
    : 0;
  const autocloseHours = duration ? Math.floor(duration.asHours()) : 0;
  const autocloseMinutes = duration ? duration.minutes() : 0;

  useEffect(() => {
    resetField('autocloseHours', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseHours : 0,
    });
    resetField('autocloseMinutes', {
      defaultValue:
        isAutocloseEnabled && currentProject?.autoclose_time_window_minutes ? autocloseMinutes : 0,
    });
  }, [isAutocloseEnabled]);

  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <AutoCloseField
        control={control}
        label={
          <div className={'flex flex-row items-center gap-2.5'}>
            Auto-close on inactivity{' '}
            <InputInfoToolTip
              contentClassName={'max-w-[350px]'}
              infoToolTip={{
                description:
                  'Automatically mark conversations as resolved when customers have not responded within the set time.',
                side: 'right',
              }}
            />
          </div>
        }
        toggleName={'autocloseEnabled'}
        limitHourName={'autocloseHours'}
        limitMinuteName={'autocloseMinutes'}
        disabled={!isAutocloseEnabled}
      />
      {/*<Separator className={'bg-[#E3E6E8]'} />*/}
      {/*<ResponseDelayField*/}
      {/*  control={control}*/}
      {/*  name={'response_delay'}*/}
      {/*  minname={'response_delay_min'}*/}
      {/*  secname={'response_delay_sec'}*/}
      {/*  disabled={true}*/}
      {/*  className={'mt-2.5'}*/}
      {/*/>*/}
      {/*<Separator className={'bg-[#E3E6E8]'} />*/}
      {/*<div className={'my-2.5 flex flex-row gap-2.5'}>*/}
      {/*  <Controller*/}
      {/*    control={control}*/}
      {/*    name={'create_ticket_summary'}*/}
      {/*    render={({ field: { onChange, value }, fieldState: { error } }) => (*/}
      {/*      <Switch*/}
      {/*        defaultChecked={value}*/}
      {/*        checked={value}*/}
      {/*        onCheckedChange={onChange}*/}
      {/*        disabled={true}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  />*/}
      {/*  <div className="flex flex-col gap-2.5">*/}
      {/*    <label className="flex flex-row gap-1.5 items-center opacity-80 font-semibold text-sm text-ebony font-jamjuree">*/}
      {/*      <span>Create ticket summary for escalations</span>*/}
      {/*      <InputInfoToolTip*/}
      {/*        infoToolTip={{*/}
      {/*          side: 'right',*/}
      {/*          description: (*/}
      {/*            <>*/}
      {/*              Create the ticket summary as an*/}
      {/*              <br /> internal note in your Help Desk.*/}
      {/*            </>*/}
      {/*          ),*/}
      {/*        }}*/}
      {/*      />*/}
      {/*    </label>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};
